import { Component, Input, OnInit } from '@angular/core';
import { DialogService } from '../../../core/services/dialog.service';
import { LeadsService } from '../../../core/services/leads.service';
import { FeatureService, PermissionService } from '../../../core/services/permission';
import { UserService } from '../../../core/services/user';
import { RepoClientsService } from '../../../data/repositories/repo-clients.service';
import { SharedDataService } from '../../../data/services/shared-data.service';
import { ContactsService } from '../../contacts/contacts.service';
import { ClientsService } from '../clients.service';
import { BxUnverifiedAlertService } from './../../../core/services/bx-unverified-alert.service';

interface LeadsCountResponse {
    leadsCountByCustomerContactId: number;
}

@Component({
    selector: 'app-client-details-list',
    styleUrls: ['./client-details-list.component.scss'],
    templateUrl: './client-details-list.component.html',
    standalone: false,
})
export class ClientDetailsListComponent implements OnInit {
    // @ts-ignore TS7008
    @Input() client;

    // @ts-ignore TS7008
    canSendSms;
    // @ts-ignore TS7008
    canSendEmail;

    constructor(
        private bxUnverifiedAlertService: BxUnverifiedAlertService,
        private contactsService: ContactsService,
        private leadsService: LeadsService,
        private clientsService: ClientsService,
        public permissionService: PermissionService,
        private featureService: FeatureService,
        private sharedData: SharedDataService,
        private customersRepo: RepoClientsService,
        private dialogService: DialogService,
        private readonly userService: UserService
    ) {}

    ngOnInit() {
        this.canSendSms =
            this.permissionService.isAvailable('customers.maintain-customer-contacts.email/sms-contacts') &&
            this.featureService.isStateAvailable('customers.maintain-customers.send-customer-sms') &&
            this.featureService.isAvailable('sms-features') &&
            this.userService.isSmsEnabled;

        this.canSendEmail =
            this.permissionService.isAvailable('customers.maintain-customer-contacts.email/sms-contacts') &&
            this.featureService.isStateAvailable('customers.maintain-customers.send-customer-email');
    }

    // @ts-ignore TS7006
    emailClient(client) {
        if (!this.sharedData.UserData.identityInfo.email_verified) {
            this.bxUnverifiedAlertService.trigger(this.sharedData.UserData.user);
            return;
        }

        this.contactsService.emailCustomerContact(client);
    }

    // @ts-ignore TS7006
    smsClient(client) {
        if (!this.sharedData.UserData.identityInfo.email_verified) {
            this.bxUnverifiedAlertService.trigger(this.sharedData.UserData.user);
            return;
        }

        this.contactsService.smsCustomerContact(client);
    }

    // @ts-ignore TS7006
    deleteClient(evt, client) {
        // @ts-ignore TS2769
        this.leadsService.getLeadsCountByCustomerContact(client.ID_CustomerContact).subscribe((res: LeadsCountResponse) => {
            const leadsCount = res.leadsCountByCustomerContactId;
            if (leadsCount > 0) {
                const firstName = client.FirstName;
                const lastName = client.LastName;
                const params = {
                    title: `Delete client ${firstName} ${lastName}?`,
                    text: `You cannot delete ${firstName} ${lastName} since it is linked to ${leadsCount} active lead.`,
                    showCancel: false,
                    okText: 'OK',
                };

                this.dialogService.show(params).then(
                    () => ({}),
                    () => ({})
                );
            } else {
                evt.stopPropagation();
                const params = {
                    title: `Delete client ${client.FirstName} ${client.LastName}?`,
                    text: "You won't be able to get this client back.",
                };
                this.dialogService.show(params).then(
                    () => {
                        client.entityAspect.setDeleted();
                        this.customersRepo.Save(client, 'Client Deleted');
                    },
                    () => ({})
                );
            }
        });
    }

    // @ts-ignore TS7006
    viewClient(client) {
        this.clientsService
            .viewClient(client)
            .then(() => ({}))
            .catch(() => ({}));
    }
}
